import styled from "styled-components";

export const Wrapper = styled.div`
  --bg: var(--app-bg);
  --surface: var(--app-surface);
  --surface2: var(--app-surface-alt);
  --border: var(--app-border);
  --border2: var(--app-border);
  --coral: #f45b68;
  --coral-d: #d94855;
  --coral-glow: rgba(244, 91, 104, 0.14);
  --navy: #314f71;
  --navy-glow: rgba(49, 79, 113, 0.12);
  --green: #22c55e;
  --text: var(--app-text);
  --text-soft: var(--app-text);
  --text-muted: var(--app-text-muted);
  --white: var(--app-surface);

  background: var(--surface);
  color: var(--text);
  height: calc(100vh - -140px);
  overflow: hidden;
  border-radius: 14px;
  font-family: "Inter", sans-serif;
  border: 1px solid var(--border);

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 65px;
    background: var(--surface);
    border-bottom: 1px solid var(--border);
    position: relative;
    z-index: 20;
    flex-shrink: 0;
    overflow: hidden;
  }

  header::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--coral), var(--navy), transparent);
    opacity: 0.6;
  }

  .logo-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
.logo-square {
    border-right: 1px solid var(--border);
    padding-right: 10px;
}
  .logo-square img{
    width: 30px;
  }

  .logo-text {
    font-family: "Inter", sans-serif;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.4px;
    color: var(--navy);
  }

  .logo-text span {
    color: var(--coral);
  }

  .hdr-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .mobile-menu-btn,
  .mobile-sidebar-head,
  .sidebar-backdrop {
    display: none;
  }

  .mobile-menu-btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 10px;
    background: var(--surface);
    color: var(--navy);
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 4px;
    padding: 0;
    cursor: pointer;
    flex-shrink: 0;
  }

  .mobile-menu-btn span {
    width: 16px;
    height: 2px;
    border-radius: 2px;
    background: currentColor;
    display: block;
  }

  .badge {
    font-family: "Inter", sans-serif;
    font-size: 10px;
    font-weight: 600;
    padding: 3px 9px;
    border-radius: 20px;
    letter-spacing: 0.4px;
    display: inline-flex;
    align-items: center;
  }

  .copilot-beta-badge {
    background: var(--coral-glow);
    color: var(--coral);
    border: 1px solid rgba(244, 91, 104, 0.28);
  }

  .credits-badge {
    background: var(--navy-glow);
    color: var(--navy);
    border-color: rgba(49, 79, 113, 0.22);
    letter-spacing: 0.2px;
    text-transform: none;
  }

  .credits-badge.exceeded {
    background: rgba(244, 91, 104, 0.18);
    color: var(--coral-d);
    border-color: rgba(244, 91, 104, 0.5);
  }

  .quota-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 10px 0 4px;
    padding: 10px 14px;
    background: rgba(244, 91, 104, 0.08);
    border: 1px solid rgba(244, 91, 104, 0.28);
    color: var(--coral-d);
    border-radius: 10px;
    font-size: 12.5px;
    line-height: 1.4;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(34, 197, 94, 0.1);
    border: 1px solid rgba(34, 197, 94, 0.22);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 500;
    color: var(--green);
  }

  .dot {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
  }

  .chat-wrap {
    display: flex;
    height: calc(100% - 62px);
    overflow: hidden;
  }

  .sidebar {
    width: 275px;
    background: var(--bg);
    border-right: 1px dashed var(--border);
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow: hidden;
    min-height: 0;
  }

  .sidebar-new-chat {
    flex-shrink: 0;
    padding: 12px 12px 10px;
    background: var(--bg);
    position: relative;
    z-index: 10;
    box-shadow: 0 6px 0 var(--bg);
    isolation: isolate;
  }

  .sidebar-new-chat::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: -32px;
    height: 32px;
    background: var(--bg);
    pointer-events: none;
  }

  .sidebar-sticky {
    flex-shrink: 0;
    padding: 16px 16px 10px;
    display: flex;
    justify-content: center;
    background: var(--bg);
    position: relative;
    z-index: 10;
    box-shadow: 0 6px 0 var(--bg);
    isolation: isolate;
  }

  .sidebar-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .sidebar-scroll {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 3px;
    overscroll-behavior: contain;
  }

  .sidebar-scroll .qq:hover {
    transform: none;
  }

  .sessions-list {
    display: flex;
    flex-direction: column;
    gap: 3px;
    isolation: isolate;
  }

  .pinned-sessions-sticky {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 3px;
    background: var(--bg);
  }

  .sessions-list > .qq.session-item {
    position: relative;
    z-index: 1;
  }

  .sidebar-scroll::-webkit-scrollbar,
  .messages::-webkit-scrollbar {
    width: 3px;
  }

  .sidebar-scroll::-webkit-scrollbar-thumb,
  .messages::-webkit-scrollbar-thumb {
    background: var(--border2);
    border-radius: 4px;
  }

  .s-label {
    font-family: "Inter", sans-serif;
    font-size: 9.7px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--text-muted);
    font-weight: 600;
    padding: 0 8px;
    margin: 14px 0 5px;
  }

  .s-label:first-child {
    margin-top: 0;
  }

  .qq {
    background: var(--surface2);
    border: 1px solid var(--surface2);
    border-radius: 9px;
    padding: 9px 12px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-soft);
    line-height: 1.4;
    text-align: left;
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: flex-start;
    cursor: pointer;
    transition: all 0.18s;
  }

  .qq:hover {
    background: var(--coral-glow);
    border-color: var(--surface2);
    color: var(--coral);
    transform: translateX(3px);
  }

  .qq.nv:hover {
    background: var(--coral-glow);
    border-color: var(--surface2);
    color: var(--coral);
  }

  .s-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--border2), transparent);
    margin: 8px 0;
  }

  .new-chat-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(135deg, var(--coral), var(--coral-d));
    color: var(--white);
    border: none;
    border-radius: 10px;
    padding: 9px 18px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    transition: all 0.18s;
    box-shadow: 0 6px 14px rgba(244, 91, 104, 0.22);
  }

  .new-chat-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(244, 91, 104, 0.28);
  }

  .new-chat-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .s-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    margin: 14px 0 5px;
  }

  .s-label-row .s-label {
    margin: 0;
    padding: 0;
  }

  .sessions-count {
    font-size: 10px;
    color: var(--text-muted);
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 1px 7px;
    font-weight: 600;
    letter-spacing: 0.3px;
  }

  .sessions-empty {
    padding: 10px 8px;
    font-size: 12px;
    color: var(--text-muted);
    text-align: center;
    font-style: italic;
  }

  .qq.session-item {
    align-items: center;
    padding: 9px 10px 9px 12px;
  }

  .qq.session-item .session-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .qq.session-item .session-title {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-soft);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.35;
  }

  .qq.session-item .session-time {
    font-size: 10.5px;
    color: var(--text-muted);
  }

  .qq.session-item:hover {
    transform: none;
  }

  .qq.session-item:hover .session-title {
    color: var(--coral);
  }

  .qq.session-item.active {
    background: var(--coral-glow);
    border-color: rgba(244, 91, 104, 0.28);
  }

  .qq.session-item.active .session-title {
    color: var(--coral);
    font-weight: 600;
  }

  .qq.session-item.loading {
    opacity: 0.6;
    pointer-events: none;
  }

  .session-action {
    background: transparent;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.15s;
    flex-shrink: 0;
  }

  .qq.session-item:hover .session-action,
  .qq.session-item.active .session-action,
  .session-action.ant-dropdown-open {
    opacity: 1;
  }

  .session-action:hover:not(:disabled) {
    background: rgba(244, 91, 104, 0.15);
    color: var(--coral);
  }

  .session-action:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .session-kebab svg {
    display: block;
  }

  .pin-indicator {
    color: var(--coral);
    margin-right: 5px;
    vertical-align: -1px;
    flex-shrink: 0;
  }

  .qq.session-item .session-title {
    display: flex;
    align-items: center;
  }

  .qq.session-item .session-title > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chat-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: var(--bg);
  }

  .messages {
    flex: 1;
    overflow-y: auto;
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .welcome {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 50px 24px 24px;
    animation: rise 0.5s ease both;
  }

  .w-icon {
  width: 85px;
  height: 85px;
  border: 1px solid var(--border2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  background: linear-gradient(
    270deg,
    #f45b68,
    #b62733,
    #ff7a59,
    #f45b68
  );

  background-size: 600% 600%;

  box-shadow: 0 8px 20px rgba(49, 79, 113, 0.1);

  animation:
    floaty 2.5s ease-in-out infinite,
    gradientMove 6s ease infinite;
}

/* Floating animation */
@keyframes floaty {
  0% {
    transform: translateY(0);
    box-shadow: 0 8px 20px #f45b6873 ;
  }

  50% {
    transform: translateY(-8px);
    box-shadow: 0 24px 30px #f45b6873 ;
  }

  100% {
    transform: translateY(0);
    box-shadow: 0 8px 20px #f45b6873;
  }
}

/* Gradient color animation */
@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

  .bot-mark {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Inter", sans-serif;
    font-weight: 700;
    letter-spacing: 0.8px;
    color: var(--white);
  }

  .welcome h2 {
    font-family: "Inter", sans-serif;
    font-size: 25px;
    font-weight: 600;
    color: var(--navy);
    margin-bottom: 10px;
    letter-spacing: -0.4px;
  }

  .welcome h2 span {
    color: var(--coral);
  }

  .welcome p {
    font-size: 14px;
    color: var(--text-muted);
    max-width: 420px;
    line-height: 1.7;
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 20px;
    max-width: 520px;
  }

  .chip {
    background: var(--surface);
    border: 1px solid var(--border2);
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 12.5px;
    color: var(--text-soft);
    cursor: pointer;
    transition: all 0.18s;
  }

  .chip:hover {
    border-color: var(--coral);
    background: var(--coral-glow);
    color: var(--coral);
  }

  .row {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    animation: rise 0.3s ease both;
  }

  .row.user {
    flex-direction: row-reverse;
  }

  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

 

  .av {
    width: 37px;
    height: 37px;
    border-radius: 50px;
    display: flex;
    // align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    overflow: hidden;
  }

  .copilot-bot-avatar-img {
    width: 24px;
    height: 24px;
    object-fit: cover;
    filter: brightness(0) invert(1);
  }

  .copilot-bot-avatar-img--welcome {
    width: 48px;
    height: 48px;
  }

  .copilot-logo-img--header {
    width: 110px;
    object-fit: contain;
  }

  .copilot-logo-img--welcome {
    width: 155px;
    object-fit: contain;
  }

  .av.bot {
    background: linear-gradient(135deg, var(--navy), color-mix(in srgb, var(--navy) 75%, #fff));
    border: 1px solid color-mix(in srgb, var(--navy) 25%, var(--border));
    box-shadow: 0 4px 10px rgba(49, 79, 113, 0.12);
  }

  .av.user {
    background: color-mix(in srgb, var(--coral) 8%, var(--surface));
    color: var(--coral);
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 700;
    border: 1px solid color-mix(in srgb, var(--coral) 28%, var(--border));
    padding: 0;
    display: block;
    position: relative;
  }

  .av.user img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .bubble {
    max-width: 65%;
    padding: 13px 16px;
    border-radius: 14px;
    font-size: 14px;
    line-height: 1.7;
  }

  .bubble.bot {
    background: var(--surface);
    // border: 1px solid var(--border);
    border-top-left-radius: 4px;
    color: var(--text);
    box-shadow: 0 6px 16px rgba(17, 24, 39, 0.05);
    max-width: calc(100% - 50px);
  }

  .md-content {
    word-break: break-word;
  }

  .md-content p {
    margin: 0 0 0.65em;
  }

  .md-content p:last-child {
    margin-bottom: 0;
  }

  .md-content strong {
    font-weight: 600;
    color: var(--navy);
  }

  .md-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0 4px;
    font-size: 13px;
  }

  .md-content th,
  .md-content td {
    border: 1px solid var(--border);
    padding: 8px 10px;
    text-align: left;
  }

  .md-content th {
    background: var(--surface2);
    font-weight: 600;
    color: var(--navy);
  }

  .md-content tr:nth-child(even) td {
    background: color-mix(in srgb, var(--surface2) 65%, transparent);
  }

  .stream-cursor {
    display: inline-block;
    width: 2px;
    height: 1em;
    margin-left: 2px;
    vertical-align: text-bottom;
    background: var(--coral);
    animation: cursorBlink 0.9s step-end infinite;
  }

  @keyframes cursorBlink {
    50% {
      opacity: 0;
    }
  }

  .tool-status {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    font-size: 12.5px;
    color: var(--text-muted);
    font-style: italic;
  }

  .tool-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--coral);
    animation: bounce 1.2s infinite;
  }

  .bubble.user {
    background: linear-gradient(135deg, #314f71, #45698f);
    border: 1px solid rgba(49, 79, 113, 0.24);
    border-top-right-radius: 4px;
    color: var(--white);
    box-shadow: 0 6px 16px rgba(49, 79, 113, 0.18);
  }

  .mgrid {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 12px;
  }

  .mc {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 11px 14px;
    min-width: 108px;
    flex: 1;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  .ml {
    font-size: 10.5px;
    color: var(--text-muted);
    font-weight: 500;
    margin-bottom: 4px;
    letter-spacing: 0.3px;
  }

  .mv {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 700;
  }

  .mv.co {
    color: var(--coral);
  }

  .mv.nv {
    color: var(--navy);
  }

  .mv.gr {
    color: var(--green);
  }

  .mch {
    font-size: 11px;
    margin-top: 2px;
    font-weight: 500;
  }

  .mch.dn {
    color: var(--coral);
  }

  .typ {
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 3px 0;
  }

  .typ span {
    width: 7px;
    height: 7px;
    background: var(--border2);
    border-radius: 50%;
    animation: bounce 1.2s infinite;
  }

  .typ span:nth-child(2) {
    animation-delay: 0.18s;
  }

  .typ span:nth-child(3) {
    animation-delay: 0.36s;
  }

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: translateY(0);
      background: var(--border2);
    }
    40% {
      transform: translateY(-6px);
      background: var(--coral);
    }
  }

  .input-bar {
    padding: 14px 24px 18px;
    background: var(--surface2);
    // border-top: 1px solid var(--border);
    flex-shrink: 0;
  }

  .irow {
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--surface);
    border: 1.5px solid color-mix(in srgb, var(--coral) 32%, var(--border));
    border-radius: 14px;
    padding: 15px 15px 15px 15px;
    transition: border-color 0.2s, box-shadow 0.2s;
    width: 100%;
  }

  .irow:focus-within {
    border-color: rgba(244, 91, 104, 0.5);
  }

  textarea {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: var(--text);
    font-size: 14px;
    resize: none;
    max-height: 110px;
    min-height: 22px;
    line-height: 1.5;
    font-family: inherit;
  }

  textarea::placeholder {
    color: var(--text-muted);
  }

  .sbtn {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--coral), var(--coral-d));
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.18s;
    box-shadow: 0 8px 18px rgba(244, 91, 104, 0.25);
  }

  .sbtn:hover:not(:disabled) {
    transform: scale(1.06);
    box-shadow: 0 10px 22px rgba(244, 91, 104, 0.32);
  }

  .sbtn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .sbtn svg {
    width: 20px;
    height: 20px;
    fill: white;
  }

  .hint {
    text-align: center;
    font-size: 11px;
    color: var(--text-muted);
    margin-top: 8px;
  }

  .hint strong {
    color: var(--text-soft);
    font-weight: 500;
  }

  @media (max-width: 991px) {
    height: calc(100dvh - 88px);
    margin-top: 12px !important;
    border-radius: 12px;

    header {
      height: 58px;
      padding: 0 12px;
      gap: 10px;
    }

    .mobile-menu-btn {
      display: inline-flex;
    }

    .logo-wrap {
      min-width: 0;
      gap: 8px;
      flex: 1;
    }

    .logo-square {
      padding-right: 8px;
    }

    .logo-text {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 15px;
      min-width: 0;
      white-space: nowrap;
    }

    .copilot-logo-img--header {
      width: 92px !important;
      max-width: 36vw;
    }

    .hdr-right {
      flex-shrink: 0;
    }

    .badge {
      font-size: 9px;
      padding: 2px 7px;
    }

    .chat-wrap {
      height: calc(100% - 58px);
      position: relative;
    }

    .sidebar-backdrop {
      display: block;
      position: fixed;
      inset: 0;
      background: rgba(17, 24, 39, 0.45);
      border: none;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
      z-index: 1040;
      padding: 0;
    }

    &.sidebar-open .sidebar-backdrop {
      opacity: 1;
      pointer-events: auto;
    }

    .sidebar {
      position: fixed;
      top: max(0px, env(safe-area-inset-top));
      left: 0;
      bottom: max(0px, env(safe-area-inset-bottom));
      width: min(86vw, 330px);
      border-right: 1px solid var(--border);
      border-radius: 0 0px 0px 0;
      box-shadow: 16px 0 36px rgba(17, 24, 39, 0.22);
      transform: translateX(-105%);
      transition: transform 0.24s ease;
      z-index: 1050;
      background: var(--bg);
    }

    &.sidebar-open .sidebar {
      transform: translateX(0);
    }

    .mobile-sidebar-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 14px 14px 8px;
      background: var(--bg);
      flex-shrink: 0;
    }

    .mobile-sidebar-title {
      color: var(--navy);
      font-size: 14px;
      font-weight: 700;
    }

    .mobile-sidebar-close {
      width: 34px;
      height: 34px;
      border: none;
      border-radius: 10px;
      background: transparent;
      color: var(--text-soft);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      padding: 0;
    }

    .sidebar-sticky {
      padding-top: 8px;
    }

    .chat-main {
      width: 100%;
      min-width: 0;
    }

    .messages {
      padding: 18px 14px;
      gap: 16px;
    }

    .welcome {
      padding: 28px 12px 18px;
    }

    .w-icon {
      width: 68px;
      height: 68px;
      margin-bottom: 22px;
    }

    .welcome h2 {
      font-size: 22px;
    }

    .copilot-logo-img--welcome {
      width: 125px !important;
    }

    .welcome p {
      font-size: 13px;
      line-height: 1.55;
    }

    .chips {
      gap: 7px;
      margin-top: 16px;
    }

    .chip {
      padding: 6px 12px;
      font-size: 12px;
    }

    .bubble {
      max-width: 90%;
      padding: 12px 13px;
      font-size: 13.5px;
    }

    .bubble.bot {
      max-width: calc(100% - 48px);
    }

    .bubble.user {
      max-width: calc(100% - 48px);
    }

    .input-bar {
      padding: 10px 10px calc(12px + env(safe-area-inset-bottom));
    }

    .irow {
      max-width: 100%;
      padding: 10px;
      border-radius: 12px;
      gap: 8px;
    }

    .sbtn {
      width: 38px;
      height: 38px;
      border-radius: 10px;
    }

    .hint {
      font-size: 10px;
      padding: 0 8px;
    }
  }

  @media (max-width: 767.99px) {
    height: calc(100dvh - 5px);
    border-left: 0;
    border-right: 0;
    border-radius: 0;

    .sidebar {
      width: min(90vw, 320px);
    }

    .logo-square img {
      width: 26px;
    }

    .logo-text span {
      display: none;
    }
    .chat-wrap textarea {
      font-size: 12px;
    }
  }

  [data-bs-theme="dark"] & {
    --navy: #a8bdd4;
    --navy-glow: rgba(168, 189, 212, 0.14);
    --coral-glow: rgba(244, 91, 104, 0.22);
    --white: #e1e3ea;

    .copilot-beta-badge {
      background: rgba(244, 91, 104, 0.2);
      color: #ff9aa3;
      border-color: rgba(244, 91, 104, 0.45);
    }

    .credits-badge {
      background: rgba(168, 189, 212, 0.14);
      color: #c8d8e8;
      border-color: rgba(168, 189, 212, 0.32);
    }

    .credits-badge.exceeded {
      background: rgba(244, 91, 104, 0.22);
      color: #ff9aa3;
      border-color: rgba(244, 91, 104, 0.5);
    }

    .logo-text,
    .welcome h2,
    .mobile-sidebar-title {
      color: var(--app-text);
    }

    .s-label {
      color: var(--app-text-muted);
    }

    .sidebar-sticky,
    .sidebar-new-chat {
      box-shadow: 0 6px 0 var(--app-bg);
    }

    .av.bot {
      background: linear-gradient(135deg, #3d5a7a, #4a6d94);
      border-color: color-mix(in srgb, var(--navy) 40%, var(--app-border));
    }

    .av.user {
      background: color-mix(in srgb, var(--coral) 12%, var(--app-surface-alt));
      border-color: color-mix(in srgb, var(--coral) 35%, var(--app-border));
    }

    .bubble.bot {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
    }

    .bubble.user {
      background: linear-gradient(135deg, #3d5a7a, #4a6d94);
      border-color: rgba(168, 189, 212, 0.2);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    .md-content strong,
    .md-content th {
      color: var(--navy);
    }

    .md-content tr:nth-child(even) td {
      background: color-mix(in srgb, var(--app-surface-alt) 80%, transparent);
    }

    .irow {
      border-color: color-mix(in srgb, var(--coral) 28%, var(--app-border));
      background: var(--app-surface);
    }

    .chip {
      background: var(--app-surface);
      border-color: var(--app-border);
    }

    .chip:hover {
      background: var(--coral-glow);
    }

    .quota-banner {
      background: rgba(244, 91, 104, 0.14);
      color: #ff9aa3;
    }

    .w-icon {
      box-shadow: 0 8px 20px rgba(244, 91, 104, 0.25);
    }
  }
`;